"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_fetcher_1 = require("../axios-fetcher");
var data_fetcher_1 = require("../data-fetcher");
var dictionary_service_1 = require("./dictionary-service");
var debug_1 = __importDefault(require("../debug"));
/**
 * Fetch dictionary data using the Sitecore Dictionary Service REST API.
 * Uses Axios as the default data fetcher (@see AxiosDataFetcher).
 */
var RestDictionaryService = /** @class */ (function (_super) {
    __extends(RestDictionaryService, _super);
    function RestDictionaryService(options) {
        var _this = _super.call(this, options) || this;
        _this.options = options;
        return _this;
    }
    Object.defineProperty(RestDictionaryService.prototype, "defaultFetcher", {
        /**
         * Provides default @see AxiosDataFetcher data fetcher
         */
        get: function () {
            var dataFetcher = new axios_fetcher_1.AxiosDataFetcher({ debugger: debug_1.default.dictionary });
            return function (url) { return dataFetcher.fetch(url); };
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Fetch dictionary data for a language.
     * @param {string} language
     */
    RestDictionaryService.prototype.fetchDictionaryData = function (language) {
        return __awaiter(this, void 0, void 0, function () {
            var endpoint, cachedValue, fetcher, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endpoint = this.getUrl(language);
                        cachedValue = this.getCacheValue(endpoint);
                        if (cachedValue) {
                            debug_1.default.dictionary('using cached dictionary data for %s %s', language, this.options.siteName);
                            return [2 /*return*/, cachedValue];
                        }
                        debug_1.default.dictionary('fetching dictionary data for %s %s', language, this.options.siteName);
                        fetcher = this.options.dataFetcher || this.defaultFetcher;
                        return [4 /*yield*/, data_fetcher_1.fetchData(endpoint, fetcher, {
                                sc_apikey: this.options.apiKey,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.setCacheValue(endpoint, response.phrases)];
                }
            });
        });
    };
    /**
     * Generate dictionary service url
     * @param {string} language
     */
    RestDictionaryService.prototype.getUrl = function (language) {
        return this.options.apiHost + "/sitecore/api/jss/dictionary/" + this.options.siteName + "/" + language;
    };
    return RestDictionaryService;
}(dictionary_service_1.DictionaryServiceBase));
exports.RestDictionaryService = RestDictionaryService;
